import Dummy from "components/Dummy";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { decode, formattedDate } from "shared/utils/Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import style from "./NoticeDetail.module.css";

function NoticeDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobile } = useContext(BrowserDetectContext);
  const [article, setArticle] = useState();
  const [articleList, setArticleList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [image, setImage] = useState();
  const [createDate, setCreateDate] = useState();
  const [status, setStatus] = useState();

  const handleNavigation = (direction) => {
    if (currentIndex === -1) return;

    let nextIndex;
    if (direction === "prev") {
      nextIndex = currentIndex - 1;
      if (nextIndex < 0) return;
    } else {
      nextIndex = currentIndex + 1;
      if (nextIndex >= articleList.length) return;
    }

    const nextArticle = articleList[nextIndex];
    navigate("/article/notice/detail", {
      state: {
        data: nextArticle,
        img: nextArticle.metadata.banner,
        articleList: articleList, // 목록 유지
        currentIndex: nextIndex, // 새로운 인덱스
      },
    });
  };

  useEffect(() => {
    if (location.state) {
      const { data, img, articleList, currentIndex } = location.state;
      setArticle(data);
      setImage(img);
      setArticleList(articleList || []); // articleList 설정 추가
      setCurrentIndex(currentIndex); // currentIndex 설정 추가
      setCreateDate(formattedDate(data.created_at));

      const endDate = data.end_date ? new Date(data.end_date) : null;
      const today = new Date();

      if (endDate === null) {
        setStatus("");
      } else if (endDate < today) {
        setStatus("종료");
      } else {
        setStatus("진행중");
      }
    }
  }, [location.state]); // location → location.state로 수정
  return (
    <Container padding={!isMobile ? "70px 0" : "30px 10px"}>
      <Container maxWidth={1000} minWidth={!isMobile && 1000}>
        <VerticalFlex flexStart gap={20}>
          {/* 현재 게시글 내용 */}
          <FlexChild>
            <P>{status && status}</P>
            <P weight={700} size={20}>
              {article && article.title}
            </P>
            <Dummy height={"5px"} />
            <P color={"rgba(79,79,79,0.5)"}>{createDate && createDate}</P>
          </FlexChild>

          <FlexChild>
            <div className={style.divider} />
          </FlexChild>

          {/* 게시글 본문 */}
          <FlexChild>
            {article && (
              <QuillViewer
              key={article.id}
                value={
                  article.content?.startsWith("PHA")
                    ? decode(article.content)
                    : article.content
                }
              />
            )}
          </FlexChild>

          {/* 이전/다음 버튼 */}
          <FlexChild>
            <HorizontalFlex justifyContent="space-between" padding="20px 0">
              <button
                onClick={() => handleNavigation("prev")}
                disabled={currentIndex <= 0}
                className={style.navigationButton}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
                <span>이전 글</span>
              </button>
              <button
                onClick={() => handleNavigation("next")}
                disabled={currentIndex >= articleList.length - 1}
                className={style.navigationButton}
              >
                <span>다음 글</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </HorizontalFlex>
          </FlexChild>

          {/* 게시글 목록 */}
          <FlexChild>
            <div className={style.divider} />
            <div className={style.articleList}>
              {articleList.map((item, index) => (
                <div
                  key={item.id}
                  onClick={() => {
                    navigate("/article/notice/detail", {
                      state: {
                        data: item,
                        img: item.metadata.banner,
                        articleList: articleList,
                        currentIndex: index,
                      },
                    });
                  }}
                  className={`${style.articleItem} ${
                    currentIndex === index ? style.currentArticle : ""
                  }`}
                >
                  <HorizontalFlex justifyContent="space-between">
                    <P
                      weight={currentIndex === index ? 700 : 400}
                      className={style.articleTitle}
                    >
                      {item.title}
                    </P>
                    <P color="rgba(79,79,79,0.5)" size={14}>
                      {formattedDate(item.created_at)}
                    </P>
                  </HorizontalFlex>
                </div>
              ))}
            </div>
          </FlexChild>
        </VerticalFlex>
      </Container>
    </Container>
  );
}

export default NoticeDetail;
